/**
 * @file: 层板流动选择线
 * @author: xiaolong.huang@dmall.com
 */

import { getFlowBorderData, FlowBorderData } from './flowBorder';

export function setFlowBorderPropertiy(cube: CubeNode, parentSelector: string = ''): void {
    let flowBorderData: FlowBorderData = getFlowBorderData();

    // 左边框流动样式
    leftBorderFlowStyle(cube, flowBorderData, parentSelector);

    // 右边框流动样式
    rightBorderFlowStyle(cube, flowBorderData, parentSelector);

    // 上边框流动样式
    topBorderFlowStyle(cube, flowBorderData, parentSelector);

    // 下边框流动样式
    bottomBorderFlowStyle(cube, flowBorderData, parentSelector);
}

function leftBorderFlowStyle(cube: CubeNode, flowBorderData: FlowBorderData, parentSelector: string): void {
    // 左边框
    let $leftBorderBox: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} > .flow-border-left`);
    let $leftBorder: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} > .flow-border-left i`);

    $leftBorderBox.css({
        width: `${flowBorderData.width}px`
    });
    $leftBorder.css({
        'height': `calc(100% + ${flowBorderData.space * 2}px)`,
        'background-size': `100% ${flowBorderData.space}px`,
        'animation-duration': `${flowBorderData.speed}ms`,
        'marginTop': `-${flowBorderData.space * 2}px`
    });
}

function rightBorderFlowStyle(cube: CubeNode, flowBorderData: FlowBorderData, parentSelector: string): void {
    // 右边框
    let $rightBorderBox: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} > .flow-border-right`);
    let $rightBorder: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} > .flow-border-right i`);

    $rightBorderBox.css({
        width: `${flowBorderData.width}px`
    });
    $rightBorder.css({
        'height': `calc(100% + ${flowBorderData.space * 2}px)`,
        'background-size': `100% ${flowBorderData.space}px`,
        'animation-duration': `${flowBorderData.speed}ms`,
        'marginTop': `-${flowBorderData.space * 2}px`
    });
}

function topBorderFlowStyle(cube: CubeNode, flowBorderData: FlowBorderData, parentSelector: string): void {
    // 上边框
    let $topBorderBox: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} .flow-border-top`);
    let $topBorder: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} .flow-border-top i`);

    $topBorderBox.css({
        height: `${flowBorderData.width}px`
    });
    $topBorder.css({
        'width': `calc(100% + ${flowBorderData.space * 2}px)`,
        'background-size': `${flowBorderData.space}px 100%`,
        'animation-duration': `${flowBorderData.speed}ms`,
        'marginLeft': `-${flowBorderData.space * 2}px`
    });
}

function bottomBorderFlowStyle(cube: CubeNode, flowBorderData: FlowBorderData, parentSelector: string): void {
    // 下边框
    let $bottomBorderBox: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} .flow-border-bottom`);
    let $bottomBorder: JQuery<HTMLElement> = cube.jView.find(`${parentSelector} .flow-border-bottom i`);

    $bottomBorderBox.css({
        height: `${flowBorderData.width}px`
    });
    $bottomBorder.css({
        'width': `calc(100% + ${flowBorderData.space * 2}px)`,
        'background-size': `${flowBorderData.space}px 100%`,
        'animation-duration': `${flowBorderData.speed}ms`,
        'marginLeft': `-${flowBorderData.space * 2}px`
    });
}
